///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class SearchMarkerView {
    private static readonly Z_INDEX = 2000;
    private marker: google.maps.marker.AdvancedMarkerElement;

    constructor(
        private readonly coordinates: google.maps.LatLngLiteral,
        private readonly title: string
    ) {}

    draw(map: google.maps.Map): void {
        if (this.marker) {
            throw new Error('Marker is defined already');
        }
        const content = new google.maps.marker.PinElement().element;
        content.style.position = 'relative';
        content.style.top = '12px';
        content.style.opacity = '0';
        content.classList.add('drop-animation');

        this.marker = new google.maps.marker.AdvancedMarkerElement({
            map,
            position: this.coordinates,
            title: this.title,
            zIndex: SearchMarkerView.Z_INDEX,
            content: content,
            gmpClickable: false
        });
    }

    hide(): void {
        if (!this.marker) {
            return;
        }

        this.marker.map = null;
        this.marker = undefined;
    }
}
